import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { sendClarityEvent, sendGTMEvent } from "../utils/analytics";
import { formatRange } from "../utils/helpers";

export const ThankYouPage = () => {
	const { data, setData, centers, isTransitioning } = useContext(AppContext);
	const [selectedCenter, setSelectedCenter] = useState(null);
	const [dropoffRange, setDropoffRange] = useState(data.startTime);
	// const [pickupRange, setPickupRange] = useState(data.endTime);

	const formatDate = (date) => {
		const newDate = new Date(date);
		return new Intl.DateTimeFormat("es-ES", {
			day: "numeric",
			month: "long",
			year: "numeric",
		}).format(newDate);
	};

	useEffect(() => {
		if (
			data.bookingType === "bookingExpress" &&
			data.damageArea === "replacement"
		) {
			setDropoffRange(formatRange(data.startTime, 0, 30));
			// setPickupRange(formatRange(data.endTime, -15, 0));
		}
		sendClarityEvent("fc-confirmada");
		sendGTMEvent("fc-confirmada", {
			origin: data.origin,
			locator: data.locator,
		});
		sessionStorage.removeItem("Data");
		// add cross-site message to parent window
		window.parent.postMessage(
			{
				type: "cita-confirmada",
				data: {
					origin: data.origin,
					name: data.name,
					email: data.email,
					phone: data.phone,
					booking: data,
				},
			},
			"*"
		);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		if (data.centerId) {
			centers.forEach((center) => {
				if (center.id === data.centerId) {
					setSelectedCenter(center);
				}
			});
		}
		setData({
			...data,
			locator: null,
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [data.centerId, centers]);

	return (
		<div
			className={
				"content content_thank_you kensei_03" +
				(isTransitioning ? " fade-in" : "")
			}
		>
			<h2 className="confirm_taller_h2">¡Gracias por tu reserva!</h2>
			{selectedCenter && (
				<div className="confirm_taller">
					<h3 className="confirm_date_h3">Taller</h3>
					<h4 className="confirm_taller_h4">
						<img
							src="resources/icons/location_lime.svg"
							alt="Ubicacion"
						/>
						<span>{selectedCenter.name}</span>
					</h4>
					<p className="confirm_taller_p">{selectedCenter.address}</p>
				</div>
			)}
			<div className="confirm_date">
				<h3 className="confirm_date_h3">Cita</h3>
				<div className="confirm_date_details">
					<h4 className="confirm_date_h4">
						<span>Código: </span>
						{data.code}
					</h4>
					<h4 className="confirm_date_h4">
						{/* <img
							src="resources/icons/calendar_lime.svg"
							alt="Fecha"
						/> */}
						<span>Día: </span>
						{formatDate(data.date)}
					</h4>
					<h4 className="confirm_date_h4">
						{/* <img src="resources/icons/clock_lime.svg" alt="Hora" /> */}
						<span>Entrega: </span>
						{dropoffRange}
					</h4>
					{data.endTime && data.damageArea === "replacement" && (
						<h4 className="confirm_date_info">
							{data.damageGlass.includes("Lateral")
								? "Sustitución en 2 horas aproximadamente"
								: "Sustitución en 2,5 horas aproximadamente"}
						</h4>
					)}
				</div>
			</div>
			<div className="confirm_info">
				<h3 className="confirm_info_h3">Tus datos</h3>
				<div className="confirm_info_details">
					<h4 className="confirm_info_h4">{data.name}</h4>
					<p className="confirm_info_plate">
						<span>Matrícula: </span>
						{data.plate}
					</p>
					<p className="confirm_info_p">{data.email}</p>
					<p className="confirm_info_p">{data.phone}</p>
				</div>
			</div>
			<div className="confirm_location">
				<a
					href={selectedCenter && selectedCenter.url}
					target="_blank"
					rel="noreferrer"
				>
					<img src="resources/icons/location.svg" alt="Ubicacion" />
					<p>Cómo llegar</p>
				</a>
			</div>
		</div>
	);
};
